module.exports = __webpack_public_path__ + "img/tray-dish-svgrepo-com.07e330f8.svg";